import type { CheckoutSession } from "./types";

/**
 * Underpaid, but nothing is due any more: a top-up covering the rest is still confirming. The
 * payer sees it confirm, not a request to pay.
 */
export function toppedUp(s: CheckoutSession): boolean {
  return s.status === "underpaid" && s.addresses.length > 0 && s.addresses.every((a) => a.due === null);
}

/** Only follow http(s) merchant URLs, never javascript: or other schemes. */
export function safeUrl(url: string | null): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    return u.protocol === "https:" || u.protocol === "http:" ? u.toString() : null;
  } catch {
    return null;
  }
}
